import comp from "./EventDetails";
export default comp;
